import React from 'react'
import './locations.css'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/Large-screens/3.png"


const locations = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
  )
}

export default locations